import { Line } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, LinearScale, PointElement, CategoryScale } from 'chart.js';
import * as R from 'ramda';
import ChartsMixin from '@/mixins/ChartsMixin.vue';
import { DashedLinesToAxis, htmlLegendPlugin, ColorEvolutionValues } from "@/utils/dashboard/charts_plugins.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, PointElement, CategoryScale, ChartDataLabels, DashedLinesToAxis, htmlLegendPlugin, ColorEvolutionValues);
export default {
  name: 'LineChart',
  components: {
    Line
  },
  mixins: [ChartsMixin],
  props: {
    data: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    x2Label: {
      type: String,
      default: ''
    },
    metricColor: {
      type: String
    },
    showEvolution: {
      type: Boolean
    }
  },
  data() {
    return {
      defaultOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          dashedLinesToAxis: {
            enabled: true
          },
          colorEvolutionValues: {
            enabled: true
          },
          legend: {
            display: false // hide default legend
          },
          htmlLegend: {
            containerID: 'chart-indicators'
          },
          tooltip: {
            titleFont: {
              family: 'Figtree, sans-serif'
            },
            bodyFont: {
              family: 'Figtree, sans-serif'
            }
          }
        },
        scales: {
          x: {
            ticks: {
              font: {
                family: 'Figtree, sans-serif',
                size: 12
              }
            },
            grid: {
              display: false,
              drawBorder: false
            }
          },
          y: {
            grid: {
              drawBorder: false
            }
          }
        }
      }
    };
  },
  computed: {
    mergedOptions() {
      return R.mergeDeepRight(this.defaultOptions, this.options || {});
    }
  }
};